import script from "./forgot-password-finish-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./forgot-password-finish-page.vue?vue&type=script&setup=true&lang=ts"

import "./forgot-password-finish-page.vue?vue&type=style&index=0&id=080e08f8&lang=less"

const __exports__ = script;

export default __exports__